import $ from 'jquery';

export default class CookieBanner {
    constructor( $el = $('.cookie-banner'), duration = 365, cookieName = "COOKIE_LVL" ) {
        this.$el    = $el;
        this.COOKIE = {
            DURATION: duration,
            NAME:     cookieName
        };

        this.CLASSES = {
            HIDDEN: 'cookie-banner--hidden'
        };

        this.SELECTORS = {
            ACCEPT:     '.js-cookiebanner-accept',
            ACCEPT_ALL: '.js-cookiebanner-accept-all',
            SETTINGS:   {
                CONTAINER: '.js-cookiebanner-settings',
                TOGGLE:    '.js-cookiebanner-togglesettings'
            },
            DESC:       '.js-cookiebanner-desc'
        };

        this.COOKIE_NAME = 'COOKIE_LVL';

        this.registerHooks();
    }

    registerHooks() {
        let _this = this;
        $(this.SELECTORS.ACCEPT).click(function( e ) {
            e.preventDefault();
            let cookieLvl = 1;
            $('[name="cookie_lvl"]').each(( i, radio ) => {
                let $radio = $(radio);
                if ( $radio.prop('checked') !== true ) {
                    return;
                }
                cookieLvl = $radio.val();
            });
            _this.setCookie(_this.COOKIE.NAME, cookieLvl, _this.COOKIE.DURATION);
            _this.$el.addClass(_this.CLASSES.HIDDEN);
        });

        $(this.SELECTORS.ACCEPT_ALL).click(function( e ) {
            e.preventDefault();
            let cookieLvl = 3;
            _this.setCookie(_this.COOKIE.NAME, cookieLvl, _this.COOKIE.DURATION);
            _this.$el.addClass(_this.CLASSES.HIDDEN);
        });

        $(this.SELECTORS.SETTINGS.TOGGLE).click(function( e ) {
            e.preventDefault();
            $(_this.SELECTORS.SETTINGS.CONTAINER).slideToggle();
            $(_this.SELECTORS.DESC).slideToggle();
        });

        console.log(this.readCookie(this.COOKIE_NAME));

        if ( this.readCookie(this.COOKIE_NAME) === "" ) {
            _this.$el.removeClass(_this.CLASSES.HIDDEN);
        }
    }

    setCookie( name, value, days ) {
        var expires = "";
        if ( days ) {
            var date = new Date();
            date.setTime(date.getTime() + ( days * 24 * 60 * 60 * 1000 ));
            expires = "; expires=" + date.toUTCString();
        }
        document.cookie = name + "=" + ( value || "" ) + expires + "; path=/";
    }

    readCookie( name ) {
        let cname         = name + "=";
        let decodedCookie = decodeURIComponent(document.cookie);
        let ca            = decodedCookie.split(';');
        for ( let i = 0; i < ca.length; i++ ) {
            let c = ca[i];
            while ( c.charAt(0) == ' ' ) {
                c = c.substring(1);
            }
            if ( c.indexOf(cname) == 0 ) {
                return c.substring(cname.length, c.length);
            }
        }
        return "";
    }
}
